import * as _4 from 'lodash4';

export interface IMajorDataToggle {
  salary: boolean;
  hiringDemand: boolean;
  tution: boolean;
  devCourses: boolean;
  courseMaps: boolean;
  credits: boolean;
}

export class MajorDataToggleService {
  private flags: IMajorDataToggle;

  constructor() {
    this.flags = {
      salary: true,
      hiringDemand: true,
      tution: true,
      devCourses: true,
      courseMaps: true,
      credits: false
    };
  }

  get toggles(): IMajorDataToggle {
    return this.flags;
  }

  setToggles(flagValues: IMajorDataToggle): void {
    this.flags = { ...this.flags, ...flagValues };
  }

  setToggle(key: string, value: boolean): void {
    if (_4.has(this.flags, key)) {
      this.flags[key] = value;
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/services/major_data_toggle_service.ts